import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import { useSearchParams } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import { createNotification } from '../../../Config/NotificationToast';
import styled from '@emotion/styled';
import Select from "react-select";
import { FormGroup, Label, } from "reactstrap";
import { deleteGuest, } from '../../../redux/actions/UserManagementAction/GuestUserAction/GuestUserAction';
import {
    stableSort,
    getComparator,
    rowOptions,

} from '../../../utils/Helper'
import { useSelector, useDispatch } from 'react-redux';
import './DeleteRequest.scss';
import { CircularProgress, Typography } from '@mui/material';
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import {ReactComponent as Recover} from "../../../assets/images/recover.svg";
import { Modal } from 'react-bootstrap';
import { guestType, tabKeys } from '../../../Config/Constant';
import moment from 'moment';
import { deleteAccountPermanently, getDeletedReqUsers, recoverAccount } from '../../../redux/actions/UserManagementAction/DeleteRequestAction/DeleteRequestAction';
import CustomModal from '../../../components/CustomModal/CustomModal';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))


const headCells = [
    {
        id: 'first_name',
        disablePadding: true,
        label: 'FIRST NAME',
    },
    {
        id: 'last_name',
        disablePadding: false,
        label: 'LAST NAME',
    },
    {
        id: 'email_id',
        disablePadding: false,
        label: 'EMAIL ADDRESS',
    },
    {
        id: 'delete_req_at',
        disablePadding: false,
        label: 'REQUESTED ON',
    },
    {
        id: 'schedule_delete',
        disablePadding: false,
        label: 'AUTO DELETE BY',
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        width: '260px',
        disableSorting: true
    },
];

const EnhancedTableHead=(props)=> {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='left'
                        sx={{minWidth: headCell.width || '195px'}}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        
                    >
                        <TableSortLabel
                            active={headCell.disableSorting ? false : orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            hideSortIcon={headCell.disableSorting}
                            disabled={headCell.disableSorting}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc', '']),
    orderBy: PropTypes.string.isRequired,
};

const EnhancedTableToolbar=(props)=> {
    const { setShowLoader, activeTab } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text')  || '');


    useEffect(() => {
        if (activeTab == tabKeys.userManagement.DELETE_REQUESTS) {
            setSearchText(searchParams.get('filter_text') || '');
        }
    }, [activeTab, searchParams]);
    

    const handleChangeSearch = (e) => {
        setShowLoader(true)
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    }


    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 }
            }}
            >
                <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        User List
                    </MainHeading>
                </div>
                <div className='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-9 p-0 GuestUserLevelDiv'>
                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}


export const DeleteRequest = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') || "");
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [viewGuestListMainData, setViewGuestListMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const {loading} = useSelector(state => state.deleteRequestReducer);
    const viewUserListDat = useSelector(state => state.deleteRequestReducer);
    const viewUserListDataRes = useSelector(state => state.deleteRequestReducer.userList);
    const dispatch = useDispatch();
    const { permission, activeTab } = props;
    
    let getData=()=>{
        const sendRequest = {
            "page_no": searchParams.get('page_no') || 1,
            "page_size": searchParams.get('limit') || 10,
            "filter_text": searchParams.get('filter_text') || '',
            "order": searchParams.get('order_by_type') || '',
            "orderBy": searchParams.get('order_by') || '',
        };
        dispatch(getDeletedReqUsers(sendRequest));
    }

    let getTableData=()=>{
        if(viewUserListDataRes && viewUserListDataRes?.data?.start === viewUserListDataRes?.data?.end){
            const newParams = new URLSearchParams(searchParams);
            newParams.set("page_no", (viewUserListDataRes?.data?.current_page_no - 1 || 1));
            setSearchParams(newParams, { replace: true });
        }else{
            const sendRequest = {
                "page_no": viewUserListDataRes?.data?.current_page || 1,
                "page_size": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "order": searchParams.get('order_by_type') || '',
                "orderBy": searchParams.get('order_by') || '',
            };
            dispatch(getDeletedReqUsers(sendRequest));
        }
    }

    useEffect(() => {
        if (activeTab == tabKeys.userManagement.DELETE_REQUESTS) {
            getData();
            setOrder(searchParams.get('order_by_type') || '');
            setOrderBy(searchParams.get('order_by') || '');
        }else{
            setOrder('');
            setOrderBy('');
            setRowsPerPage(10)
        }

    }, [activeTab, searchParams]);

    useEffect(()=>{
        if(!loading)
            setShowLoader(false)
        if(!loading && !viewUserListDataRes?.data?.data && !viewUserListDat.error){
            setShowLoader(true)
        }
    }, [loading])

    useEffect(() => {
        if (viewUserListDat.error !== "No data available to show for guests users") {
            setViewGuestListMainData(viewUserListDataRes && viewUserListDataRes?.data?.data);
        } else {
            setViewGuestListMainData("");
        }
    }, [viewUserListDataRes, viewUserListDat])

    const handleRequestSort = (event, property) => {

        const isAsc = orderBy === property && order === "asc";
        let newOrder = isAsc ? "desc" : "asc";
        setOrder(newOrder);
        setOrderBy(property);
    
        const newParams = new URLSearchParams(searchParams);
        if (property) {
            newParams.set('order_by', property);
        } else {
            newParams.delete('order_by');
        }
        if (newOrder) {
            newParams.set('order_by_type', newOrder);
        } else {
            newParams.delete('order_by_type'); // Only include params with values
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewUserListDataRes && viewUserListDataRes.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePageNext = () => {
        setShowLoader(true)
        const nextPage = viewUserListDataRes?.data?.current_page + 1;
        const newParams = new URLSearchParams(searchParams);
        if (nextPage !== 1) {
            newParams.set('page_no', nextPage.toString());
        } else {
            newParams.delete('page_no');
        }
        setSearchParams(newParams, { replace: true });
    };
    const handleChangePagePrev = () => {
        setShowLoader(true)
        const prevPage = viewUserListDataRes?.data?.current_page - 1;
        const newParams = new URLSearchParams(searchParams);
        if (prevPage !== 1) {
            newParams.set('page_no', prevPage.toString());
        } else {
            newParams.delete('page_no');
        }
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);

        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('limit', newRowsPerPage.toString());
        } else {
            newParams.delete('limit');
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    };



    return (
        <>
            <Box sx={{ width: '100%' }} className="DeleteRequestBox h-100">
              <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                    <EnhancedTableToolbar numSelected={selected.length} 
                        order={order}
                        orderBy={orderBy}
                        activeTab={activeTab}
                        showLoader={showLoader}
                        setShowLoader={setShowLoader}
                        rowsPerPageNos={rowsPerPage} />
                    {
                        showLoader ?
                        <div className='w-100 py-5 text-center'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                        :
                        viewGuestListMainData?.length > 0 ? <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                size='small'
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewUserListDataRes && viewUserListDataRes?.length}
                                />
                                <TableBody>
                                    {
                                        viewGuestListMainData
                                            .map((row, index) => {
    
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow hover onClick={(event) => handleClick(event, row.firstName)} role="checkbox"
    
                                                        tabIndex={-1}
                                                        key={row.id}
    
                                                    >
                                                        <TableCell component="th" id={labelId} scope="row" padding="none" sx={{ minWidth: '140px', maxWidth: '140px', wordWrap: 'break-word'}}>{row.first_name}</TableCell>
                                                        <TableCell align="left" sx={{minWidth: '150px', maxWidth: '150px', wordWrap: 'break-word'}}>{row.last_name}</TableCell>
                                                        <TableCell align="left" >{row.email_id}</TableCell>
                                                        <TableCell align="left" >{moment(row?.delete_req_at)?.format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell align="left" >{moment(row?.schedule_delete)?.format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell align="left" className='View'> 
                                                            <ul className="list-group d-flex flex-row">
                                                            <RecoverButton
                                                                row={row}
                                                                getTableData={getTableData}
                                                            />
                                                            <DeleteButton
                                                                row={row}
                                                                getTableData={getTableData}
                                                            />    
                                                            </ul>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        : <div className='text-center w-100 text-muted mt-3'>No Records</div>
                    }
                </Paper>
                {
                    viewGuestListMainData
                    &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                                menuPlacement="top"
                                menuPosition="fixed"
                                styles={{
                                    menu: (base) => ({
                                        ...base,
                                        top: 'auto',
                                        bottom: 0,
                                    }),
                                }}
                            />
                        </FormGroup>
                        {viewUserListDataRes?.data && <p className='endText'>   {viewUserListDataRes?.data?.start} - {viewUserListDataRes?.data?.end} of {viewUserListDataRes?.data?.total}</p>}
                        <p>
                            
                            <button className={`btnPrev ${viewUserListDataRes?.data?.current_page === 1 ? "opacityBtns" : ''}`} disabled={viewUserListDataRes?.data?.current_page === 1} onClick={() => { handleChangePagePrev() }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button> 
                            <button className={`btnPrev ${viewUserListDataRes?.data?.current_page === viewUserListDataRes?.data?.total_pages ? "opacityBtns" : ''}`} disabled={viewUserListDataRes?.data?.current_page === viewUserListDataRes?.data?.total_pages} onClick={() => { handleChangePageNext() }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>
                }
            </Box>
        </>
        );
}


const RecoverButton = ({row, getTableData})=>{
    const dispatch= useDispatch()
    const [showModel, setShowModel] = useState(false)
    const loading = useSelector(state => state.deleteRequestReducer.updateLoader);
    const onRecover=()=>{
        dispatch(recoverAccount({id: row?.id, onSuccessCallback: ()=>{
            setShowModel(false)
            getTableData()
        }}))
    }
    return (
        <>
            <li className={'list-group-item ViewEditClick p-0 mr-3'} onClick={()=>setShowModel(true)}><Recover width={28}/> Recover</li>
            <CustomModal
                show={showModel}
                setShow={setShowModel}
                title='Account Recovery'
                content={`Are you sure you want to recover ${row?.first_name} ${row.last_name}’s account.`}
                onClickNo={()=>setShowModel(false)}
                onClickYes={onRecover}
                loading={loading}
            />
        </>
    )
}

const DeleteButton = ({row, getTableData})=>{
    const dispatch= useDispatch()
    const loading = useSelector(state => state.deleteRequestReducer.updateLoader);
    const [showModel, setShowModel] = useState(false)
    const onDelete=()=>{
        dispatch(deleteAccountPermanently({id: row?.id, onSuccessCallback: ()=>{
            setShowModel(false)
            getTableData()
        }}))
    }
    return (
        <>
            <li className="list-group-item Delete p-0" onClick={()=>setShowModel(true)}><img src={Delete} className="mr-1 mb-1" alt="Avatar" width="14px" height="16px" /> Delete Account</li>
            <CustomModal
                show={showModel}
                setShow={setShowModel}
                title='Delete Account'
                content={`Are you sure you want to delete ${row?.first_name} ${row.last_name}’s account.`}
                onClickNo={()=>setShowModel(false)}
                onClickYes={onDelete}
                loading={loading}
            />
        </>
    )
}